const defaultState = {
  socio: {
    dni: 33134865,
    nombre: "SANTIAGO ALARCON",
    plan: "5e29e3e515cbc6637e99d567",
    version: "5e29e3e515cbc63ef599d568",
  },
  plan: null,
  allPrestaciones: null,
  listaDePrecios: null,
  historialSocio: [],
  validaciones: [],
  carrito: [],
  mascotas: [],
  cantidadMascotas: 0,
  alerta: "",
  nombrePlan: "",
  servicios_prestador: null,
  idPrestador: null,
  comprobante: null,
  contratos: null,
  SOCIO_CON_DEUDA: null,
  PLAN_NO_APLICA: null,
  SIN_DESCUENTO: "",
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "GET_PLAN_SOCIO":
      return {
        ...state,
        plan: {
          ...action.payload.plan,
          versiones: action.payload.plan.versiones.filter(
            (v) => v._id === action.payload.version
          ),
        },
        nombrePlan: action.payload.nombrePlan,
      };
    case "GET_PRESTACIONES_SOCIO":
      return {
        ...state,
        allPrestaciones: action.payload,
      };
    case "GET_PRESTADOR_PRECIOS":
      return {
        ...state,
        listaDePrecios: action.payload,
      };
    case "VALIDAR_REGLAS":
      return {
        ...state,
        validaciones: state.validaciones.concat(action.payload),
      };
    case "CLEAN_VALIDACIONES":
      return {
        ...state,
        validaciones: [],
      };
    case "ADD_CARRITO":
      return {
        ...state,
        carrito: state.carrito.concat(action.payload.linea),
        historialSocio: state.historialSocio.map((h) => {
          return h.idPrestacion == action.payload.idGrupo &&
            h.orden == action.payload.linea.mascota
            ? {
                ...h,
                cantidadMensual:
                  h.cantidadMensual + parseInt(action.payload.linea.cantidad),
                cantidadAnual:
                  h.cantidadAnual + parseInt(action.payload.linea.cantidad),
                cantidadAnual_socio:
                  h.cantidadAnual_socio +
                  parseInt(action.payload.linea.cantidad),
                cantidadMensual_socio:
                  h.cantidadMensual_socio +
                  parseInt(action.payload.linea.cantidad),
              }
            : h;
        }),
      };
    case "DEL_ITEM_CARRITO":
      return {
        ...state,
        historialSocio: state.historialSocio.map((h) => {
          return h.idPrestacion == action.payload.idGrupo &&
            h.orden == action.payload.orden
            ? {
                ...h,
                cantidadMensual:
                  h.cantidadMensual - parseInt(action.payload.cantidad),
                cantidadAnual:
                  h.cantidadAnual - parseInt(action.payload.cantidad),
                cantidadAnual_socio:
                  h.cantidadAnual_socio - parseInt(action.payload.cantidad),
                cantidadMensual_socio:
                  h.cantidadMensual_socio - parseInt(action.payload.cantidad),
              }
            : h;
        }),
        carrito: state.carrito.filter((linea, index) => {
          return index !== action.payload.index;
        }),
      };
    case "CANCELAR_CONSULTA_SOCIO":
      return {
        ...state,
        validaciones: [],
        carrito: [],
        mascotas: [],
        historialSocio: [],
        socio: {},
        plan: null,
        alerta: "",
        contratos: null,
        SOCIO_CON_DEUDA: null,
        PLAN_NO_APLICA: null,
        SIN_DESCUENTO: "",
      };
    case "BUSCAR_SOCIO_POR_NUM":
      return {
        ...state,
        socio: {
          dni: action.payload.numero_documento,
          nombre: action.payload.apellido_nombres,
          plan: action.payload.plan,
          version: action.payload.codigo_servicio_mascota24,
        },
      };
    case "BUSCAR_SOCIO_POR_DNI":
      return {
        ...state,
        contratos: action.payload,
      };
    case "GET_MASCOTAS_POR_CONTRATO":
      return {
        ...state,
        mascotas: action.payload,
        cantidadMascotas: action.payload.length,
      };
    case "SET_ALERTA":
      return {
        ...state,
        alerta: action.payload,
      };
    case "GET_SERVICIOS_PRESTADOR":
      return {
        ...state,
        servicios_prestador: action.payload,
      };
    case "GET_HISTORIAL":
      return {
        ...state,
        historialSocio: state.historialSocio
          .map((h) => {
            return h.idPrestacion == action.payload.idPrestacion &&
              h.orden == action.payload.orden
              ? {
                  ...h,
                  cantidadMensual:
                    h.cantidadMensual + parseInt(action.payload.linea.cantidad),
                  cantidadAnual:
                    h.cantidadAnual + parseInt(action.payload.linea.cantidad),
                  cantidadAnual_socio:
                    h.cantidadAnual_socio +
                    parseInt(action.payload.linea.cantidad),
                  cantidadMensual_socio:
                    h.cantidadMensual_socio +
                    parseInt(action.payload.linea.cantidad),
                }
              : h;
          })
          .concat(action.payload),
      };
    case "SET_COMPROBANTE":
      return {
        ...state,
        comprobante: action.payload,
      };
    case "SET_IDPRESTADOR":
      return {
        ...state,
        idPrestador: action.payload,
      };
    case "SOCIO_CON_DEUDA":
      return {
        ...state,
        SOCIO_CON_DEUDA: true,
      };
    case "PLAN_NO_APLICA":
      return {
        ...state,
        PLAN_NO_APLICA: true,
      };
    case "SIN_DESCUENTO":
      return {
        ...state,
        SIN_DESCUENTO: action.payload,
      };
    default:
      return state;
  }
};
